import React, { FC } from 'react'

import { AcquisitionChannel } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface AcquisitionChannelFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const AcquisitionChannelFilter: FC<AcquisitionChannelFilterProps> = props => {
  const acquisitionChannelOptions = Object.values(AcquisitionChannel).map(channel => ({
    value: channel,
    label: capitalizeEachFirstLetter(channel.replace(/_/g, ' ')),
  }))

  const optionsWithPortfolioAcquisitions = [
    ...acquisitionChannelOptions,
    { value: 'PORTFOLIO ACQUISITIONS', label: 'Portfolio Acquisitions' },
  ]

  return (
    <CheckboxBasedFilter
      isSearchEnabled
      title="Acquisition Channel"
      options={optionsWithPortfolioAcquisitions}
      {...props}
    />
  )
}
